export default function numberFormat(number: number, decimals = 0): string {
  return number.toFixed(decimals).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
